import { reduce, type, merge } from 'ramda';

const isUndefined = state => type(state) === 'Undefined';

export const composeReducers = (...reducers) => (state, action) => reduce(
  (state$, reducer) => {
    if (isUndefined(state)) {
      // state initialization
      return merge(state$, reducer(undefined, action));
    }

    return reducer(state$, action);
  },
  state,
  reducers,
);

export default {};
